import { useContext, useEffect } from "react";
import { AccountContext } from "./contexts/AccountContexts";
import { useNavigate } from "react-router-dom";


const App = () => {
    const { user } = useContext(AccountContext)
    const navigator = useNavigate()

    useEffect(() => {
        if (window.location.pathname === "/") {

            if (user) {
                if (user.class === "dev") {
                    navigator("/admin/dashboard")
                }
                else if (user.class === "user" && user.type !== "temp") {
                    navigator("/member/home")
                }
                else {
                    navigator("/home")
                }
            }
            else {
                navigator("/home")
            }
        }
        else if (window.location.pathname.startsWith("/admin") && user?.class === "user") {
            const predefinedUrl = "/member/home";
            window.location.href = predefinedUrl;
        }
        else {
            navigator(window.location.pathname)
        }
    }, [])


    return <></>
}


export default App;